<template>
  <div class="pc-page-settings__user-area">
    <avatar :size="200" :round="false" :border="true"/>
    <el-button size="small" style="margin-top:2rem" @click="changeAvatarHandler">修改头像</el-button>
  </div>
</template>

<script>
import Avatar from '@/components/avatar/Avatar.vue'
import { mapMutations } from 'vuex'

export default {
  components: {
    Avatar
  },
  methods: {
    ...mapMutations({
      setUploadAvatarDialog: 'dialog/SET_UPLOAD_AVATAR'
    }),
    changeAvatarHandler () {
      this.setUploadAvatarDialog({
        visible: true
      })
    }
  }
}
</script>

<style lang="scss">

</style>
